import { t } from "i18next";
import React from "react";
import { MyOrdersProps } from "./MyOrders";
import "./OrderDetail.css";

const OrderDetailCard: React.FC<MyOrdersProps> = ({
  id,
  date,
  image,
  price,
  status,
  personsNumber,
  isWellnessService,
  prenotazione,
}) => {
  const months = [
    t("timeFormats.monthsFirstThree.January"),
    t("timeFormats.monthsFirstThree.February"),
    t("timeFormats.monthsFirstThree.March"),
    t("timeFormats.monthsFirstThree.April"),
    t("timeFormats.monthsFirstThree.May"),
    t("timeFormats.monthsFirstThree.June"),
    t("timeFormats.monthsFirstThree.July"),
    t("timeFormats.monthsFirstThree.August"),
    t("timeFormats.monthsFirstThree.September"),
    t("timeFormats.monthsFirstThree.October"),
    t("timeFormats.monthsFirstThree.November"),
    t("timeFormats.monthsFirstThree.December"),
  ];

  let newDate = new Date(date);

  let bookingDate =
    newDate.getDate().toString() +
    " " +
    months[newDate.getMonth()] +
    " " +
    newDate.getFullYear().toString();

  // Determina lo stato effettivo basandosi su prenotazione e status
  // Flusso servizi Wellness: Da prenotare → Prenotato → Completato
  const getEffectiveStatus = () => {
    const numericStatus = typeof status === "number" ? status :
                          (typeof status === "string" && !isNaN(parseInt(status)) ? parseInt(status) : null);

    // CANCELLED: Ordine cancellato
    if (status === "CANCELLED" || numericStatus === 2) {
      return "CANCELLED";
    }

    // PENDING: In attesa di pagamento
    if (status === "PENDING" || numericStatus === 1) {
      return "PENDING";
    }

    // COMPLETED: Quando il fornitore ha confermato la consulenza
    // Status stringa "COMPLETED" o numerico 0 (ordinal dell'enum)
    if (status === "COMPLETED" || numericStatus === 0) {
      return "COMPLETED";
    }

    // Per servizi Wellness con status TO_BOOK/BOOKED o pagati:
    // Controlla il campo prenotazione per determinare lo stato
    if (status === "BOOKED" || numericStatus === 4 || prenotazione) {
      return "BOOKED";
    }

    if (status === "TO_BOOK" || numericStatus === 3) {
      return "TO_BOOK";
    }

    // Default per ordini pagati: controlla prenotazione
    if (prenotazione) {
      return "BOOKED";
    }
    return "TO_BOOK";
  };

  const effectiveStatus = getEffectiveStatus();

  return (
    <>
      <div className="orderdetail">
        <div className="orderdetail-container">
          <div className="orderdetail-title">{"Dettaglio ordine"}</div>
          <div className="orderdetail-separator" />
          <div className="orderdetail-container-description">
            <div className="myorders-container-information-second">
              <div className="myorders-container-information-second-row">
                <div className="myorders-container-information-second-text-first">
                  {t("myOrders.id")}
                </div>
                <div className="myorders-container-information-second-text-second">
                  {"#" + id}
                </div>
              </div>
              <div className="myorders-container-information-second-row">
                <div className="myorders-container-information-second-text-first">
                  {t("myOrders.date")}
                </div>
                <div className="myorders-container-information-second-text-second">
                  {bookingDate !== "" ? bookingDate : t("myOrders.notAvabile")}
                </div>
              </div>
              <div className="myorders-container-information-second-row">
                <div className="myorders-container-information-second-text-first">
                  {t("myOrders.price")}
                </div>
                <div className="myorders-container-information-second-text-second">
                  {Math.round((price ?? 0) / 0.8) + " crediti"}
                </div>
              </div>
              <div className="myorders-container-information-second-row">
                <div className="myorders-container-information-second-text-first">
                  {t("myOrders.status")}
                </div>
                <div className="myorders-container-information-second-text-second">
                  {effectiveStatus === "PENDING" && (
                    <div className="paystatus-pending">
                      {t("myOrders.payPending")}
                    </div>
                  )}
                  {effectiveStatus === "TO_BOOK" && (
                    <div className="paystatus-to-book">
                      {t("myOrders.toBook")}
                    </div>
                  )}
                  {effectiveStatus === "BOOKED" && (
                    <div className="paystatus-booked">
                      {t("myOrders.booked")}
                    </div>
                  )}
                  {effectiveStatus === "COMPLETED" && (
                    <div className="paystatus-completed">
                      {t("myOrders.payCompleted")}
                    </div>
                  )}
                  {effectiveStatus === "CANCELLED" && (
                    <div className="paystatus-canceled">
                      {t("myOrders.payCanceled")}
                    </div>
                  )}
                  {!effectiveStatus && t("myOrders.notAvabile")}
                </div>
              </div>
              <div className="myorders-container-information-second-row">
                <div className="myorders-container-information-second-text-first">
                  {t("myOrders.personsNumber")}
                </div>
                <div className="myorders-container-information-second-text-second">
                  {!!personsNumber && personsNumber > 0
                    ? personsNumber
                    : t("myOrders.notAvabile")}
                </div>
              </div>
            </div>
            {image && (
              <div className="orderdetail-image-container">
                <img className="orderdetail-image" src={image} alt="" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetailCard;
